import { useState } from "react";
import { authStore } from "../auth";
import { BrandMark } from "../components/BrandMark";
import { Button } from "../components/Button";
import { useFlow } from "../flow/FlowContext";
import { buildApplicationFromAnswers } from "../domain/buildApplication";
import { matchStore } from "../matching/matchStore";
import { reviewQueueStore } from "../review/queueStore";
import { canUseLocalStorage } from "../storage/localWrite";
import { submitProfileToServer, serverAvailable } from "../api/backend";
import { useT } from "../i18n";

export function ReadyScreen() {
  const { answers, profileAnswers } = useFlow();
  const t = useT();
  const name = answers.firstName.trim();
  const [enterError, setEnterError] = useState<string | null>(null);

  const enterMatching = async () => {
    setEnterError(null);
    if (!canUseLocalStorage()) {
      setEnterError(t("common.storageDisabled"));
      return;
    }
    let userId = authStore.getUserId();
    if (!userId) {
      const auth = await authStore.ensureRegistered(answers.email, answers.password);
      if (!auth.ok) {
        setEnterError(auth.error);
        return;
      }
      userId = auth.user.id;
    }
    const app = buildApplicationFromAnswers(answers, userId, profileAnswers);
    reviewQueueStore.submitApplication(app);

    if (await serverAvailable()) {
      const remote = await submitProfileToServer(answers, profileAnswers, { submit: true });
      if (!remote.ok) {
        setEnterError(remote.error);
        return;
      }
    }

    const self = matchStore.enterFromOnboarding(answers, userId, profileAnswers);
    if (!self) {
      setEnterError(t("ready.needGender"));
      return;
    }
    if (matchStore.sessionWriteFailed()) {
      setEnterError(t("common.storageQuota"));
      return;
    }
    await matchStore.syncFromServer();
    window.location.hash = "#/match";
  };

  return (
    <div className="ready ready--prompt screen-enter">
      <BrandMark hero />
      <div>
        <h1 className="ready__title">{t("ready.title")}</h1>
        <p className="ready__text">
          {name
            ? t("ready.textNamed", { name })
            : t("ready.text")}
        </p>
      </div>
      <div
        style={{
          width: "100%",
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          gap: 10,
        }}
      >
        {enterError ? <p className="capture__error">{enterError}</p> : null}
        <Button onClick={() => void enterMatching()}>{t("ready.enterMatching")}</Button>
      </div>
    </div>
  );
}
